import moment from "moment";

function normalizeDateTimeValue(value) {
  return String(value).replace(" ", "T");
}

export function formatDateValue(date, format, locale = "en") {
  return moment(date)
    .locale(locale)
    .format(format);
}

export function formatDateHoursValue(value, locale = "en") {
  return moment(normalizeDateTimeValue(value))
    .locale(locale)
    .format("ddd DD MMM HH:mm");
}

export function formatHoursMinutesValue(value, isTwelveHour = false) {
  return moment(normalizeDateTimeValue(value)).format(
    isTwelveHour ? "h:mm A" : "HH:mm"
  );
}

export function isPastDateTimeValue(value) {
  return new Date(normalizeDateTimeValue(value)) < new Date();
}